import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.get-credit-card-account.presenters.CreditCardStatementDetailsPresenter`

export default defineMessages({
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Unable to load the credit card account.',
  },
})
